// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0;
  display: none;
}

input[type="date"]::-moz-focus-inner {
  border: 0;
}



.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Hide scrollbar for WebKit-based browsers (Chrome, Safari, Edge) */
.scrollbar-none::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for Firefox */
.scrollbar-none {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}





/* === FullCalendar Grid Line Fix === */
/* === Vertical Resource Grid Lines for resourceTimeGridDay === */
/* === Vertical lines for Carrier View (timeGridWeek) === */
/* .fc .fc-timegrid-col {
  border-right: 1px solid #e5e7eb !important;
}

.fc .fc-timegrid-body {
  border-left: 1px solid #e5e7eb !important;
  border-right: 1px solid #e5e7eb !important;
}


.fc .fc-timegrid-body tr:last-child td {
  border-bottom: none !important;
} */



/* src/index.css or src/styles/global.css */
.Toastify__toast {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
.Toastify__toast-body {
  padding: 0 !important;
  margin: 0 !important;
}




`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,0BAA0B;AACtD;;;;;;AAMA,uCAAuC;AACvC,iEAAiE;AACjE,2DAA2D;AAC3D;;;;;;;;;;;;GAYG;;;;AAIH,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  display: none;\n}\n\ninput[type=\"date\"]::-moz-focus-inner {\n  border: 0;\n}\n\n\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Hide scrollbar for WebKit-based browsers (Chrome, Safari, Edge) */\n.scrollbar-none::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for Firefox */\n.scrollbar-none {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n}\n\n\n\n\n\n/* === FullCalendar Grid Line Fix === */\n/* === Vertical Resource Grid Lines for resourceTimeGridDay === */\n/* === Vertical lines for Carrier View (timeGridWeek) === */\n/* .fc .fc-timegrid-col {\n  border-right: 1px solid #e5e7eb !important;\n}\n\n.fc .fc-timegrid-body {\n  border-left: 1px solid #e5e7eb !important;\n  border-right: 1px solid #e5e7eb !important;\n}\n\n\n.fc .fc-timegrid-body tr:last-child td {\n  border-bottom: none !important;\n} */\n\n\n\n/* src/index.css or src/styles/global.css */\n.Toastify__toast {\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.Toastify__toast-body {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
